import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=cinematic%20movie%20theater%20interior%20with%20warm%20red%20velvet%20curtains%20and%20dim%20golden%20lighting%2C%20elegant%20and%20dramatic%20atmosphere%2C%20empty%20theater%20with%20spotlight%2C%20luxurious%20classic%20cinema%20aesthetic%2C%20soft%20glow%20from%20screen%2C%20dark%20moody%20background&width=1800&height=900&seq=hero-bg-02&orientation=landscape"
        alt="牛牛影视 - 免费高清影视聚合平台"
        title="牛牛影视 - 免费追剧在线观看"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full px-4 md:px-6 text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-black font-heading text-background-50 mb-4 tracking-tight">
            免费追剧，<span className="text-primary-400">畅享无限</span>
          </h1>
          <p className="text-sm md:text-lg text-background-100/90 max-w-2xl mx-auto mb-8 leading-relaxed">
            牛牛影视全站免费，覆盖电影大全、电视剧全集、热门综艺与精品动漫，
            高清流畅不缓冲，打造免费影视聚合入口。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/movie"
              className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-fill text-xl"></i>
              立即观影
            </Link>
            <Link
              to="/category/tv"
              className="inline-flex items-center gap-2 px-8 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 font-semibold rounded-full hover:bg-background-50/25 border border-background-50/20 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-tv-2-line text-lg"></i>
              热门剧集
            </Link>
          </div>

          <div className="flex items-center justify-center gap-6 mt-10">
            {[
              { num: '10万+', label: '影视资源' },
              { num: '1080P', label: '高清画质' },
              { num: '0元', label: '完全免费' },
              { num: '99.9%', label: '流畅播放' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <p className="text-xl md:text-2xl font-bold text-accent-400 font-heading">{stat.num}</p>
                <p className="text-xs text-background-100/70 mt-1">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}